import { StyledLink, Paragraph } from 'components/layouts/SharedStyles';
import { mailtoLink } from 'utils';
import { config } from 'config';
const { EMAIL_CONTACT, TECH_CONTACT } = config;

export const IntroHeader = () => {
  return (
    <>
      <Paragraph>Join us for the 2026 Corvallis Contra Dance Weekend!</Paragraph>
      <Paragraph>
        Registration system questions? Email <StyledLink to={mailtoLink(TECH_CONTACT)}>{TECH_CONTACT}</StyledLink>.<br />
        Any other questions? Email <StyledLink to={mailtoLink(EMAIL_CONTACT)}>{EMAIL_CONTACT}</StyledLink>.
      </Paragraph>
      <Paragraph><em>After you hit save, there will be an opportunity to add additional attendees.</em></Paragraph>
    </>
  );
};
